import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from 'app/admin/admin.service';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { ConfirmService } from 'app/shared/dialog/confirm.service';


@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  title: string;
  confirmButtonText: string;
  declineButtonText: string;
  content: string[];

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: { title: string , content: string[], confirmButtonText: string, declineButtonText: string}, 
    private confirmService: ConfirmService
  ) {}

  ngOnInit() {
    this.title = this.data.title;
    this.content = this.data.content;
    this.confirmButtonText = this.data.confirmButtonText || "כן";
    this.declineButtonText = this.data.declineButtonText || "לא";
  }

  confirm(): void 
  {
    this.confirmService.confirm();
    
    let closeSubscription = this.confirmService.closeDialog$.subscribe((closeDialog :boolean) => {
      if(closeDialog)
      {
        closeSubscription.unsubscribe();
        this.dialogRef.close(true);
      }  
    });
  }

}